export const READ_URL = "https://eu-west-2.cdn.hygraph.com/content/clwpr25ce026s07utzbqbby4u/master";

export const getStage = () => (true ? "stage: PUBLISHED" : "stage: DRAFT");

// Hygraph rate limits us, which we hit if we're precompiling all the blog posts. This slows the build down
export function avoidRateLimit(delay = 200) {
  if (!process.env.IS_BUILD) {
    return;
  }

  return new Promise(resolve => {
    setTimeout(resolve, delay);
  });
}

function buildRequest(query: string) {
  query = query.replaceAll("{STAGE}", getStage());
  query = query.replaceAll("\n", " ");
  query = query.replaceAll('"', '\\"');

  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: `{"query":"${query.replaceAll("\n", " ")}"}`,
  };
}

async function query(q: string) {
  await avoidRateLimit();
  return await fetch(READ_URL, buildRequest(q));
}

export default query;
